import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { ApiBaseUrl } from "../../http";
import { QueryUrl } from "../../Utils";
import { prepareHeaders } from "../user/user.api";
import { TypeQuery,PaginationResults } from "../user/user.type";
import { Vendeur, VendeurFormData } from "./vendeur.type";

export const VendeurApi = createApi({
  reducerPath: "vendeurApi",
  tagTypes: [
    "vendeur",
    "vendeurList",
    "vendeurByVisitor",
    "vendeurBySlug",
    "allVendeurList",
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    getListvendeurAdmin: builder.query<PaginationResults<Vendeur>, TypeQuery>({
      providesTags: ["vendeurList"],
      query: (query) => QueryUrl("vendeurs", query),
    }),
    getVendeurList: builder.query<PaginationResults<Vendeur>, TypeQuery>({
      providesTags: ["vendeur"],
      query: (query) => QueryUrl("payment-method/", query),
    }),
    addOrEditVendeur: builder.mutation<Vendeur,{ slug?: string; data: VendeurFormData | FormData }>({
      onCacheEntryAdded(arg, { dispatch }) {
        setTimeout(() => {
          dispatch(
            VendeurApi.util.invalidateTags([
              "vendeurList",
              "vendeurByVisitor",
              "vendeur",
            ])
          );
        }, 1000);
      },
      query: ({ slug, data }) => {
        if (slug) {
          return {
            url: `vendeur/update/${slug}/`,
            method: "PUT",
            body: data,
          };
        }
        return {
          url: `vendeurs/`,
          method: "POST",
          body: data,
        };
      },
    }),
    deleteVendeur: builder.mutation<Vendeur, string>({
      query: (slug) => ({
        url: `vendeurs/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: [
        "vendeur",
        "vendeurList",
        "vendeurByVisitor",
      ],
    }),
    vendeurBySlug: builder.query<Vendeur | any, string>({
      query: (id) => `payment-method/${id}/`,
      providesTags: ["vendeurBySlug"],
    }),
  }),
});

export const {
  useAddOrEditVendeurMutation,
  useDeleteVendeurMutation,
  useGetListvendeurAdminQuery,
  useGetVendeurListQuery,
} = VendeurApi;
